import { Expose, Type } from "class-transformer";
import ShopRes from "../shop/ShopRes";

export default class AdditionalTimeRes {
  @Expose() readonly additionalTimeId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly totalFee!: number;
  @Expose() readonly shopFee!: number;
  @Expose() readonly driverFee!: number;
  @Expose() readonly time!: number;
  @Type(() => ShopRes)
  @Expose()
  readonly shops!: ShopRes[];
}
